/* global dataLayer */
const optimizely = window.optimizely || [];

const mktoAnalytics = {
  setOptimizelyEvents(prefix, event, postfix) {
    if (!prefix) return;
    const optimizelyMessage = postfix ? `${prefix}-${event}-${postfix}` : `${prefix}-${event}`;
    optimizely.push(['trackEvent', optimizelyMessage]);
  },

  optimizelyXEvent(eventName) {
    optimizely.push({
      type: 'event',
      eventName,
    });
  },

  setSteps(step, steps, valueClick, prefix, gaPrefix, id) {
    const formAction = 'Click';
    const fieldValue = valueClick.currentTarget.innerText;
    const formStep = step;
    const gaEvent = gaPrefix ? `${gaPrefix}PSG` : 'PSG';
    if (id !== '2342'){
      dataLayer.push({ event: gaEvent, formAction, fieldValue, formStep });
    }

    if (!prefix) return;
    let optimizelyMessage = `${prefix}-`;
    optimizelyMessage += step >= steps ? 'POSG-Results' : (`POSG-Step${step}complete`);
    optimizely.push(['trackEvent', optimizelyMessage]);
  },

  setErrors(form, step) {
    setTimeout(() => {
      const errorArray = form.getFormElem().find('.mktoError');
      if (errorArray.length === 1) {
        const formAction = 'Error';
        const fieldValue = errorArray[0].textContent;
        const fieldName = errorArray[0]
          .parentNode.querySelector('label')
          .innerText.replace(/[^a-zA-Z ]/g, '');
        const formStep = step;
        if (step) {
          dataLayer.push({ event: 'PSG', formAction, fieldName, fieldValue, formStep });
        } else {
          dataLayer.push({ event: 'webForm', formAction, fieldName, fieldValue });
        }
      }
    }, 500);
  },

  setVirtualThankYouPage() {
    dataLayer.push({
      event: 'vpConfirmation',
      virtualPageUrl: '/thank-you-confirmation',
      virtualPageTitle: 'Thank You | ShopKeep',
    });
  },
};

export default mktoAnalytics;
